var map = {
	"./coin": 9182,
	"./coin.json": 9182,
	"./coin.png": 3108,
	"./enemy": 8263,
	"./enemy.json": 8263,
	"./enemy.png": 7504,
	"./hero": 292,
	"./hero.json": 292,
	"./hero.png": 6387,
	"./npc_01": 6142,
	"./npc_01.json": 6142,
	"./npc_01.png": 9615,
	"./npc_02": 3550,
	"./npc_02.json": 3550,
	"./npc_02.png": 9533,
	"./npc_03": 5212,
	"./npc_03.json": 5212,
	"./npc_03.png": 4130,
	"./npc_04": 5460,
	"./npc_04.json": 5460,
	"./npc_04.png": 8776,
	"./npc_05": 1254,
	"./npc_05.json": 1254,
	"./npc_05.png": 2195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 4506;
module.exports = webpackContext;